module.exports = __webpack_public_path__ + "img/mt_clickbait_style_casino.fbf3a893.svg";